// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* frontend/src/styles/systemStatusWidget.css */

.system-status-widget {
  border: none;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
}

.system-status-widget .card-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 12px 12px 0 0 !important;
  border: none;
}

.system-status-widget .card-header h5 {
  font-weight: 600;
}

.status-metric {
  display: flex;
  align-items: center;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 10px;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  height: 100%;
}

.status-metric:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.metric-icon {
  font-size: 2.5rem;
  margin-right: 15px;
  opacity: 0.8;
}

.metric-info {
  flex: 1 1;
}

.metric-value {
  font-size: 1.8rem;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 5px;
}

.metric-label {
  font-size: 0.9rem;
  color: #6c757d;
  margin-bottom: 8px;
}

.metric-badge {
  font-size: 0.7rem;
  padding: 3px 8px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .status-metric {
    padding: 10px;
    margin-bottom: 10px;
  }
  
  .metric-icon {
    font-size: 2rem;
    margin-right: 10px;
  }
  
  .metric-value {
    font-size: 1.5rem;
  }
  
  .metric-label {
    font-size: 0.8rem;
  }
}

/* 动画效果 */
.system-status-widget {
  animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 加载状态 */
.loading-placeholder {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
}

@keyframes loading {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/systemStatusWidget.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;EACE,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,uCAAuC;EACvC,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,SAAS;AACT;EACE,gCAAgC;AAClC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,SAAS;AACT;EACE,yEAAyE;EACzE,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF","sourcesContent":["/* frontend/src/styles/systemStatusWidget.css */\n\n.system-status-widget {\n  border: none;\n  border-radius: 12px;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  margin-bottom: 20px;\n}\n\n.system-status-widget .card-header {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border-radius: 12px 12px 0 0 !important;\n  border: none;\n}\n\n.system-status-widget .card-header h5 {\n  font-weight: 600;\n}\n\n.status-metric {\n  display: flex;\n  align-items: center;\n  padding: 15px;\n  background: #f8f9fa;\n  border-radius: 10px;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n  height: 100%;\n}\n\n.status-metric:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n}\n\n.metric-icon {\n  font-size: 2.5rem;\n  margin-right: 15px;\n  opacity: 0.8;\n}\n\n.metric-info {\n  flex: 1;\n}\n\n.metric-value {\n  font-size: 1.8rem;\n  font-weight: bold;\n  color: #2c3e50;\n  margin-bottom: 5px;\n}\n\n.metric-label {\n  font-size: 0.9rem;\n  color: #6c757d;\n  margin-bottom: 8px;\n}\n\n.metric-badge {\n  font-size: 0.7rem;\n  padding: 3px 8px;\n}\n\n/* 响应式设计 */\n@media (max-width: 768px) {\n  .status-metric {\n    padding: 10px;\n    margin-bottom: 10px;\n  }\n  \n  .metric-icon {\n    font-size: 2rem;\n    margin-right: 10px;\n  }\n  \n  .metric-value {\n    font-size: 1.5rem;\n  }\n  \n  .metric-label {\n    font-size: 0.8rem;\n  }\n}\n\n/* 动画效果 */\n.system-status-widget {\n  animation: slideIn 0.3s ease-out;\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* 加载状态 */\n.loading-placeholder {\n  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);\n  background-size: 200% 100%;\n  animation: loading 1.5s infinite;\n}\n\n@keyframes loading {\n  0% {\n    background-position: 200% 0;\n  }\n  100% {\n    background-position: -200% 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
